export default __webpack_public_path__ + "static/schin-70c93920fc7589d17ab115020cbe17ea.jpg";